import React, {  } from 'react';
import styles from 'assets/css/SMARTGoal.module.css';
import buttonStyles from 'assets/css/Button.module.css';
import { withCardLinkIconWrap } from 'Components/Card/CardLink';
import { IconAngleRight } from '@ace/react-icons';
import { useSMARTGoalPageState, useSMARTGoalPageNavigation } from 'context/SMARTGoalAppContext';
import useSMARTGoalOverlay from 'context/SMARTGoalOverlayContext';

const IconAngleRightWrap = withCardLinkIconWrap(IconAngleRight);

const BtnTemplate = (props) => (
    <span className={props.classes} style={{cursor: 'pointer'}} onClick={() => props.onClickFn()}>
        {props.beforeIconTxt && props.beforeIconTxt}<IconAngleRightWrap />{props.afterIconTxt && props.afterIconTxt}
    </span>
);

export default function SMARTGoalNavigation() {
    const { currentPage, maxPages } = useSMARTGoalPageState();
    const { prevPage, nextPage } = useSMARTGoalPageNavigation();
    const { toggleSMARTGoalsOverlay } = useSMARTGoalOverlay();

    const GetStartedBtn = () => (<BtnTemplate classes={buttonStyles.primary} onClickFn={nextPage} beforeIconTxt="Get Started" />);
    const NextBtn = () => (<BtnTemplate classes={`${buttonStyles.primary} ${styles.nextButton}`} onClickFn={nextPage} beforeIconTxt="Next" />);
    const BackBtn = () => (<BtnTemplate classes={`${buttonStyles.stroke} ${styles.backButton}`} onClickFn={prevPage} afterIconTxt="Back" />);
    const FinishBtn = () => (<BtnTemplate classes={`${buttonStyles.primary} ${styles.nextButton}`} onClickFn={toggleSMARTGoalsOverlay} beforeIconTxt="Finish" />);

    const displayProps = {
        showBack: currentPage > 1,
        showGetStarted: currentPage === 1,
        showNext: currentPage > 1 && currentPage < maxPages,
        showFinish: currentPage === maxPages
    };

    return (
        <div className={styles["sg-navigation__btn-wrapper"]}>
            {displayProps.showBack && <BackBtn />}
            {displayProps.showGetStarted && <GetStartedBtn />}
            {displayProps.showNext && <NextBtn />}
            {displayProps.showFinish && <FinishBtn />}
        </div>
    );
}